import { t } from '@lingui/core/macro'
import { useSnackbar } from '@tecsinapse/cortex-react'
import { useCallback, useState } from 'react'
import { ConfirmModalProps } from '@/core/types/confirm-modal'

const useConfirmHelpers = <T>(
  setOpen: (state: boolean) => void,
  onConfirm: ConfirmModalProps<T>['onConfirm'],
  onCancel?: ConfirmModalProps<T>['onCancel'],
  successMessage?: ConfirmModalProps<T>['successMessage'],
  errorMessage?: ConfirmModalProps<T>['errorMessage']
) => {
  const [loading, setLoading] = useState(false)
  const { snackbar } = useSnackbar()

  const onClose = useCallback(() => setOpen(false), [setOpen])

  const handleCancel = useCallback(async () => {
    await onCancel?.()
    onClose()
  }, [onCancel, onClose])

  const handleConfirm = useCallback(async () => {
    setLoading(true)
    try {
      await onConfirm()
      snackbar.show('success', successMessage ?? t`Ação realizada com sucesso!`)
    } catch (e) {
      snackbar.show(
        'error',
        errorMessage ?? t`Não foi possível realizar a ação :(`
      )
      console.error('[ConfirmModal] Error:', e)
    } finally {
      setLoading(false)
      onClose()
    }
  }, [onConfirm, snackbar, successMessage, errorMessage, onClose])

  return {
    loading,
    onClose,
    handleCancel,
    handleConfirm
  }
}

export default useConfirmHelpers
